import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useDeleteTemplate = (onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.DELETE_TEMPLATE],
    (id) => ApiService.deleteTemplate(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_TEMPLATE);
        onClose()
        toast.success('Template deleted successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useDeleteTemplate